"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NavMenuContext = void 0;

var _react = require("react");

var NavMenuContext = (0, _react.createContext)({
  expandedMenuId: null,
  handleMenuClick: function handleMenuClick() {
    return null;
  }
});
exports.NavMenuContext = NavMenuContext;